import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelBansCommand, } from "../commands/ListChannelBansCommand";
export const paginateListChannelBans = createPaginator(ChimeSDKMessagingClient, ListChannelBansCommand, "NextToken", "NextToken", "MaxResults");
